import "shared/ui/topbar/topbar.css";

import {
  ArrowBack,
  ArrowDownward,
  ArrowForward,
  ArrowUpward,
} from "@mui/icons-material";
import {
  Box,
  Drawer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { defaultStore } from "shared/common/stores/defaultStore";
import {
  MouseLeftClick,
  MouseRightClick,
} from "shared/common/utils/icons/icons";

interface Props {
  role: string;
  showShortcut: boolean;
  setShowShortcut: Dispatch<SetStateAction<boolean>>;
}

interface key {
  type: string;
  value: string;
}

interface tableRow {
  keys: key[];
  right: string;
}

interface table {
  title: string;
  rows: tableRow[];
}

export default function ShortcutDrawer(props: Props) {
  const darkTheme = defaultStore((state) => state.darkTheme);

  const { t } = useTranslation();

  const tablesView: table[] = [
    {
      title: t("shortcuts_drawer.player_title"),
      rows: [
        {
          keys: [
            { type: "text", value: "alt" },
            { type: "icon", value: "right" },
          ],
          right: t("shortcuts_drawer.player_key_1"),
        },
        {
          keys: [
            { type: "text", value: "alt" },
            { type: "icon", value: "left" },
          ],
          right: t("shortcuts_drawer.player_key_2"),
        },
        {
          keys: [{ type: "text", value: "space" }],
          right: t("shortcuts_drawer.player_key_3"),
        },
        {
          keys: [
            { type: "text", value: "shift" },
            { type: "text", value: "D" },
          ],
          right: t("shortcuts_drawer.player_key_4"),
        },
        {
          keys: [{ type: "text", value: "<" }],
          right: t("shortcuts_drawer.player_key_5"),
        },
        {
          keys: [{ type: "text", value: ">" }],
          right: t("shortcuts_drawer.player_key_6"),
        },
      ],
    },
    {
      title: t("shortcuts_drawer.nav_title"),
      rows: [
        {
          keys: [{ type: "icon", value: "top" }],
          right: t("shortcuts_drawer.nav_key_1"),
        },
        {
          keys: [{ type: "icon", value: "bottom" }],
          right: t("shortcuts_drawer.nav_key_2"),
        },
        {
          keys: [{ type: "icon", value: "left" }],
          right: t("shortcuts_drawer.nav_key_3"),
        },
        {
          keys: [{ type: "icon", value: "right" }],
          right: t("shortcuts_drawer.nav_key_4"),
        },
        {
          keys: [
            { type: "text", value: "shift" },
            { type: "icon", value: "bottom" },
          ],
          right: t("shortcuts_drawer.nav_key_5"),
        },
        {
          keys: [
            { type: "text", value: "shift" },
            { type: "icon", value: "left" },
          ],
          right: t("shortcuts_drawer.nav_key_6"),
        },
        {
          keys: [
            { type: "text", value: "shift" },
            { type: "icon", value: "right" },
          ],
          right: t("shortcuts_drawer.nav_key_7"),
        },
      ],
    },
  ];

  const tablesEdit: table[] = [
    {
      title: t("shortcuts_drawer.edit_title"),
      rows: [
        {
          keys: [
            { type: "icon", value: "mouse-left" },
            { type: "text", value: "drag&drop" },
          ],
          right: t("shortcuts_drawer.edit_key_1"),
        },
        {
          keys: [
            { type: "text", value: "shift" },
            { type: "icon", value: "mouse-left" },
            { type: "text", value: "drag&drop" },
          ],
          right: t("shortcuts_drawer.edit_key_2"),
        },
        {
          keys: [
            { type: "text", value: "ctrl" },
            { type: "icon", value: "mouse-left" },
          ],
          right: t("shortcuts_drawer.edit_key_3"),
        },
        {
          keys: [{ type: "text", value: "delete" }],
          right: t("shortcuts_drawer.edit_key_4"),
        },
        {
          keys: [{ type: "text", value: "delete" }],
          right: t("shortcuts_drawer.edit_key_5"),
        },
      ],
    },
    {
      title: t("shortcuts_drawer.area_title"),
      rows: [
        {
          keys: [{ type: "text", value: "delete" }],
          right: t("shortcuts_drawer.area_key_1"),
        },
      ],
    },
    {
      title: t("shortcuts_drawer.cursor_title"),
      rows: [
        {
          keys: [{ type: "text", value: "ctrl" }],
          right: t("shortcuts_drawer.cursor_key_1"),
        },
      ],
    },
  ];

  const notNeededTable: table[] = [
    // {
    //   title: "Anonymization",
    //   rows: [
    //     {
    //       keys: [{ type: "text", value: "ctrl" }],
    //       right: "Change category",
    //     },
    //     {
    //       keys: [
    //         { type: "text", value: "alt" },
    //         { type: "text", value: "gr" },
    //       ],
    //       right: "Activate/deactivate labeling tool",
    //     },
    //     {
    //       keys: [{ type: "text", value: "a" }],
    //       right: "Show right/left image (if supported)",
    //     },
    //     {
    //       keys: [{ type: "text", value: "d" }],
    //       right: "Activate/deactivate labeling mode of static objects",
    //     },
    //   ],
    // },
    // {
    //   title: "Anonymization (in review mode)",
    //   rows: [
    //     {
    //       keys: [{ type: "icon", value: "right" }],
    //       right: "Change category",
    //     },
    //     {
    //       keys: [{ type: "icon", value: "left" }],
    //       right: "Activate/deactivate labeling tool",
    //     },
    //     {
    //       keys: [
    //         { type: "text", value: "delete" },
    //         { type: "icon", value: "right" },
    //       ],
    //       right:
    //         "Remove all upcoming frames and labels of the current camera form the review sequence",
    //     },
    //     {
    //       keys: [
    //         { type: "text", value: "delete" },
    //         { type: "icon", value: "left" },
    //       ],
    //       right:
    //         "Remove all current and all previous frames and labels of the current camera form the review sequence",
    //     },
    //     {
    //       keys: [
    //         { type: "text", value: "delete" },
    //         { type: "icon", value: "bottom" },
    //       ],
    //       left: "delete + arrow down",
    //       right:
    //         "Remove the current frame and its label from the review sequence",
    //     },
    //     {
    //       keys: [{ type: "text", value: "ctrl" }],
    //       right: "select a label",
    //     },
    //     {
    //       keys: [{ type: "text", value: "enter" }],
    //       right: "accept and close review mode",
    //     },
    //     {
    //       keys: [{ type: "text", value: "a" }],
    //       right: "Show right/left image (if supported)",
    //     },
    //     {
    //       keys: [{ type: "text", value: "c" }],
    //       right:
    //         "Recalculate label propagation in upcoming frames after repositioning the current label",
    //     },
    //     {
    //       keys: [{ type: "icon", value: "mouse-right" }],
    //       right: "Abort review mode (no labels will be saved)",
    //     },
    //   ],
    // },
    // {
    //   title: "Orthogonal measurement",
    //   rows: [
    //     {
    //       keys: [{ type: "text", value: "ctrl" }],
    //       right: "Continue measurement",
    //     },
    //   ],
    // },
    // {
    //   title: "In LR-Measure",
    //   rows: [
    //     {
    //       keys: [{ type: "icon", value: "right" }],
    //       right: "Move measure to the right",
    //     },
    //     {
    //       keys: [{ type: "icon", value: "left" }],
    //       right: "Move measure to the left",
    //     },
    //     {
    //       keys: [
    //         { type: "text", value: "ctrl" },
    //         { type: "icon", value: "top" },
    //       ],
    //       right: "Move measure up",
    //     },
    //     {
    //       keys: [
    //         { type: "text", value: "ctrl" },
    //         { type: "icon", value: "bottom" },
    //       ],
    //       right: "Move measure down",
    //     },
    //     {
    //       keys: [{ type: "text", value: "enter" }],
    //       right: "Change image",
    //     },
    //     {
    //       keys: [{ type: "text", value: "c" }],
    //       right: "Change crosshair",
    //     },
    //   ],
    // },
  ];

  const tables: table[] =
    props.role === "edit" ? [...tablesView, ...tablesEdit] : tablesView;

  return (
    <Drawer
      anchor={"right"}
      open={props.showShortcut}
      onClose={() => props.setShowShortcut(false)}
      classes={{
        root: "infra3d-drawerRoot",
        paper: darkTheme
          ? "infra3d-paperBackgroundDark"
          : "infra3d-paperBackgroundLight",
      }}
    >
      {tables.map((item, index) => (
        <Table
          key={index}
          aria-label="sticky table"
          sx={{
            marginBottom: 2,
            backgroundColor: darkTheme ? "darkblue.main" : "white",
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell align="left" colSpan={2}>
                <Typography
                  color={darkTheme ? "white" : "darkblue.main"}
                  variant="body1"
                  fontWeight={600}
                >
                  {item.title}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {item.rows.map((row: tableRow, rowIndex: number) => (
              <TableRow
                key={rowIndex}
                sx={{ borderBottom: "1px rgb(224,224,224) solid" }}
              >
                <TableCell
                  sx={{
                    border: "none",
                    padding: "6px 16px",
                    width: "100%",
                    maxWidth: { xs: "100px", md: "200px", xl: "300px" },
                  }}
                >
                  <Typography
                    color={darkTheme ? "white" : "darkblue.main"}
                    variant="body2"
                    fontWeight={400}
                  >
                    {row.right}
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    border: "none",
                    padding: "6px 16px",
                    maxWidth: { xs: "100px", md: "120px", xl: "150px" },
                    minWidth: { xs: "100px", md: "120px", xl: "150px" },
                  }}
                >
                  <Box
                    display="flex"
                    width="100%"
                    justifyContent="flex-end"
                    gap={1}
                  >
                    {row.keys?.map((item: key, index: number) => (
                      <Box
                        key={index}
                        paddingX={"8px"}
                        paddingY={"0px"}
                        borderRadius={"4px"}
                        border={"1px rgb(224,224,224) solid"}
                        sx={{ backgroundColor: "white" }}
                        boxShadow={3}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        {item.type === "text" && (
                          <Typography fontSize={"12px"}>
                            {item.value}
                          </Typography>
                        )}
                        {item.type === "icon" && item.value === "top" && (
                          <ArrowUpward
                            sx={{ fontSize: "16px", paddingY: "4px" }}
                          />
                        )}
                        {item.type === "icon" && item.value === "right" && (
                          <ArrowForward
                            sx={{ fontSize: "16px", paddingY: "4px" }}
                          />
                        )}
                        {item.type === "icon" && item.value === "bottom" && (
                          <ArrowDownward
                            sx={{ fontSize: "16px", paddingY: "4px" }}
                          />
                        )}
                        {item.type === "icon" && item.value === "left" && (
                          <ArrowBack
                            sx={{ fontSize: "16px", paddingY: "4px" }}
                          />
                        )}
                        {item.type === "icon" &&
                          item.value === "mouse-right" && <MouseRightClick />}
                        {item.type === "icon" &&
                          item.value === "mouse-left" && <MouseLeftClick />}
                      </Box>
                    ))}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ))}
    </Drawer>
  );
}
